var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import setIfNotSet from "@irati/utils/setIfNotSet";
import userErrorHandler from "./errors/legacy/userErrorHandler";
import authentication from "../../auth";
import updateUserMutation, { updateUserKey } from "./mutations/updateUser";
import createUserMutation, { createUserKey } from "./mutations/createUser";
import getUserQuery, { getUserKey } from "./queries/getUser";
import getUsersQuery from "./queries/getUsers";
import getUsersForBusiness from "./queries/usersForBusiness";
import getUserByEmailQuery from "./queries/getUserByEmail";
import updateUsersByEmailMutation, { updateUsersByEmailKey } from "./mutations/updateUsersByEmail";
import makeUserManagerMutation, { makeUserManagerKey } from "./mutations/makeUserManager";
import makeUserLeaderMutation, { makeUserLeaderKey } from "./mutations/makeUserLeader";
import makeUserGlobalAdminMutation, { makeUserGlobalAdminKey } from "./mutations/makeUserGlobalAdmin";
import makeUserBasicMutation, { makeUserBasicKey } from "./mutations/makeUserBasic";
import activateUserMutation from "./mutations/activateUser";
import deactivateUserMutation from "./mutations/deactivateUser";
import unAuthedUserQuery, { unAuthedUserKey } from "./queries/unAuthedUser";
import fullUser from "./fragments/fullUserV4";
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserService.prototype.get = function (userId, _a, options) {
        var _b = (_a === void 0 ? {} : _a).withTeams, withTeams = _b === void 0 ? false : _b;
        if (options === void 0) { options = {}; }
        var variables = { id: userId, withTeams: withTeams };
        return client.query(__assign(__assign({}, options), { query: getUserQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[getUserKey];
        });
    };
    UserService.prototype.getUserByEmail = function (email, tenantId) {
        if (tenantId === void 0) { tenantId = authentication.userTenant().uuid; }
        var variables = { email: email, tenantId: tenantId };
        return client.query({ query: getUserByEmailQuery, variables: variables }).then(function (res) { return res.data.getUserByEmail; });
    };
    UserService.prototype.unAuthedUser = function (uuid, options) {
        if (options === void 0) { options = {}; }
        var variables = { id: uuid };
        return client
            .query(__assign(__assign({}, options), { metadata: { unAuth: true }, query: unAuthedUserQuery, variables: variables }))
            .then(function (res) { return res.data[unAuthedUserKey]; });
    };
    UserService.prototype.list = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: getUsersQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data.users;
        });
    };
    UserService.prototype.getUsersForBusiness = function (variables, options) {
        if (options === void 0) { options = {}; }
        setIfNotSet(variables, "includeBusiness", false);
        setIfNotSet(variables, "businessId", authentication.business().uuid);
        return client.query(__assign(__assign({}, options), { query: getUsersForBusiness, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data.usersForBusiness;
        });
    };
    UserService.prototype.create = function (_a, options) {
        if (options === void 0) { options = {}; }
        var _b = _a.withTeams, withTeams = _b === void 0 ? false : _b, args = __rest(_a, ["withTeams"]);
        var variables = {
            user: args.user,
            withTeams: withTeams
        };
        return client.mutate(__assign(__assign({}, options), { mutation: createUserMutation, variables: variables })).then(function (res) { return res.data[createUserKey]; });
    };
    UserService.prototype.update = function (_a, options) {
        if (options === void 0) { options = {}; }
        var _b = _a.withTeams, withTeams = _b === void 0 ? false : _b, args = __rest(_a, ["withTeams"]);
        var variables = {
            user: args.user,
            withTeams: withTeams
        };
        return client.mutate(__assign(__assign({}, options), { mutation: updateUserMutation, variables: variables })).then(function (res) { return res.data[updateUserKey]; });
    };
    UserService.prototype.updateUsersByEmail = function (users, tenantId) {
        if (tenantId === void 0) { tenantId = authentication.userTenant().uuid; }
        var variables = { users: users, tenantId: tenantId };
        return client.mutate({ mutation: updateUsersByEmailMutation, variables: variables }).then(function (res) {
            return res.data[updateUsersByEmailKey];
        });
    };
    UserService.prototype.activate = function (user, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            userId: user.uuid
        };
        return client.mutate(__assign(__assign({}, options), { mutation: activateUserMutation, variables: variables })).then(function () {
            patchUserToCache(user.uuid, { isEnabled: true });
            return true;
        });
    };
    UserService.prototype.deactivate = function (user, options) {
        if (options === void 0) { options = {}; }
        var variables = {
            userId: user.uuid
        };
        return client.mutate(__assign(__assign({}, options), { mutation: deactivateUserMutation, variables: variables })).then(function () {
            patchUserToCache(user.uuid, { isEnabled: false });
            return true;
        });
    };
    UserService.prototype.makeUserBasic = function (teamId, userId, options) {
        if (options === void 0) { options = {}; }
        var variables = { teamId: teamId, userId: userId };
        return client.mutate(__assign(__assign({}, options), { mutation: makeUserBasicMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            patchUserToCache(userId, { isGlobalAdmin: false });
            return data[makeUserBasicKey];
        });
    };
    UserService.prototype.makeUserManager = function (teamId, userId, options) {
        if (options === void 0) { options = {}; }
        var variables = { teamId: teamId, userId: userId };
        return client.mutate(__assign(__assign({}, options), { mutation: makeUserManagerMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[makeUserManagerKey];
        });
    };
    UserService.prototype.makeUserLeader = function (teamId, userId, options) {
        if (options === void 0) { options = {}; }
        var variables = { teamId: teamId, userId: userId };
        return client.mutate(__assign(__assign({}, options), { mutation: makeUserLeaderMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[makeUserLeaderKey];
        });
    };
    UserService.prototype.makeUserGlobalAdmin = function (userId, options) {
        if (options === void 0) { options = {}; }
        var variables = { userId: userId };
        return client.mutate(__assign(__assign({}, options), { mutation: makeUserGlobalAdminMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            patchUserToCache(userId, { isGlobalAdmin: true });
            return data[makeUserGlobalAdminKey];
        });
    };
    return UserService;
}(PBService));
var service = new UserService({ errorHandlers: [userErrorHandler] });
export default service;
function patchUserToCache(userId, data) {
    var user = client.readFragment({ id: "User@" + userId, fragment: fullUser, fragmentName: "fullUser" });
    var updatedUser = __assign(__assign({}, user), data);
    client.writeFragment({ id: "User@" + userId, fragment: fullUser, fragmentName: "fullUser", data: updatedUser });
    return updatedUser;
}
